module.exports = __webpack_public_path__ + "static/RO_form_RU-ca7d4cf56293ba940b44962af62fc272.pdf";